import store from "../store";
import baseService from "../services/base.service";

//utils
import {getAllBasket} from './my-basket'

//actions
import {setCardLoading} from '../actions/property-search'

//devextreme
import notify from 'devextreme/ui/notify';


const postPropertyToCart = async (floors,propertyId) => {
  try {
        store.dispatch(setCardLoading(true))
        const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart`;
        let formData = new FormData()
        formData.append('PropertyId',propertyId)
        floors.forEach(floor => {
            formData.append('FloorPlanTypes',floor)
        });
      
        await baseService.post(url,formData,{
          headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
          },
        }
        )
        .then(data => {
          notify('Property added to cart', "success" , 3000)
          getAllBasket()
        })
        .finally(()=>{
          store.dispatch(setCardLoading(false))
        })
        .catch(error => {
          store.dispatch(setCardLoading(false))
          notify(error.response.data, "error" , 3000);
        })
    }
  catch (error) {
    store.dispatch(setCardLoading(false))
    notify('Something went wrong try again later', "error" , 3000);
  }
}
const putPropertyToCart = async (floors,propertyId) => {
  try {
        store.dispatch(setCardLoading(true))
        const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart`;
        let formData = new FormData()
        formData.append('PropertyId',propertyId)
        floors.forEach(floor => {
            formData.append('FloorPlanTypes',floor)
        });      
        await baseService.put(url,formData,{
          headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
          },
        }
        )
        .then(data => {
          notify('Property added to cart', "success" , 3000)
          getAllBasket()
        })
        .finally(()=>{
          store.dispatch(setCardLoading(false))
        })
        .catch(error => {
            notify(error.response.data, "error" , 3000);
            store.dispatch(setCardLoading(false))
        })
    }
  catch (error) {
    store.dispatch(setCardLoading(false))
    notify('Something went wrong try again later', "error" , 3000);
  }
}
const deletePropertyInCart = async (propertyId) => {
  try {
        store.dispatch(setCardLoading(true))
        const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart/all`;
        const formData = new FormData()
        formData.append('PropertyId', propertyId)
        await baseService.delete(url, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formData
        }).then(data => {
          notify(`Property ${propertyId} has been removed from the cart.`, "success", 3000);
        }).finally(()=>{
          store.dispatch(setCardLoading(false))
        }).catch(error =>{
          store.dispatch(setCardLoading(false))
          notify(error, "error", 3000);
        })
    }
  catch (error) {
    store.dispatch(setCardLoading(false))
    notify('Something went wrong try again later', "error" , 3000);
  }
}
export { postPropertyToCart , putPropertyToCart, deletePropertyInCart}